import { API_NAME, REDUX_STORE } from '@funnels/constants';
import { CustomersActionTypes, CustomersReducerState, SharedActionTypes } from '@funnels/types';

const initialState: CustomersReducerState = {
  data: [],
  error: null,
  loading: 0,
};

export default function assetsReducer(
  state: CustomersReducerState = initialState,
  action: CustomersActionTypes | SharedActionTypes
): CustomersReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.CLEAR_CUSTOMER_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMER_ME:
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMERS:
      return {
        ...state,
        data: [],
        loading: state.loading + 1,
      };
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMER_ME_SUCCESS:
      return {
        ...state,
        data: [action.customer],
        loading: state.loading - 1,
      };
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        data: action.customers,
        loading: state.loading - 1,
      };
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.SET_CUSTOMER_ERROR:
      // TODO: FUNNEL-1606 - use same pattern in employment reducer, setting error message in same action as fail/abort
      return {
        ...state,
        error: {
          name: API_NAME.CUSTOMERS,
          message: action.message,
        },
      };
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.UPDATE_CUSTOMERS:
      return {
        ...state,
        loading: state.loading + 1,
        data: state.data.map((storeCustomer) => {
          const updatedCustomer = action.customers.find((c) => c.id === storeCustomer.id);
          if (updatedCustomer) {
            return { ...storeCustomer, ...updatedCustomer };
          }
          return storeCustomer;
        }),
      };
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.UPDATE_CUSTOMERS_SUCCESS:
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMER_ME_FAIL:
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMERS_FAIL:
    case REDUX_STORE.CUSTOMERS.ACTION_TYPES.UPDATE_CUSTOMERS_FAIL:
      return {
        ...state,
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
